import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DollarSign, Package, ShoppingCart, Users, ArrowRight } from "lucide-react";
import api, { formatBRL } from "@/lib/api";
import AdminLayout from "./AdminLayout";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
    api.get("/admin/orders").then((r) => setOrders(r.data.slice(0, 6)));
  }, []);

  const cards = [
    { label: "Receita (pagos)", value: formatBRL(stats?.revenue), icon: DollarSign },
    { label: "Pedidos", value: stats?.total_orders ?? "—", icon: ShoppingCart },
    { label: "Produtos", value: stats?.total_products ?? "—", icon: Package },
    { label: "Clientes", value: stats?.total_customers ?? "—", icon: Users },
  ];

  return (
    <AdminLayout title="Painel">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <div key={c.label} data-testid={`stat-${c.label}`} className="bg-[#0f0f0f] border border-white/5 p-6 hover:border-[#B89C65]/40 transition-colors">
              <div className="flex items-center justify-between">
                <span className="overline text-white/40">{c.label}</span>
                <Icon size={18} className="text-[#B89C65]" />
              </div>
              <div className="font-serif text-3xl mt-4">{c.value}</div>
            </div>
          );
        })}
      </div>

      <div className="flex items-center justify-between mt-12 mb-4">
        <h2 className="font-serif text-2xl">Pedidos recentes</h2>
        <Link to="/admin/pedidos" className="overline text-white/50 hover:text-[#B89C65] flex items-center gap-2 transition-colors">Ver todos <ArrowRight size={14} /></Link>
      </div>
      <div className="bg-[#0f0f0f] border border-white/5">
        {orders.length === 0 ? (
          <div className="p-8 text-white/40 text-sm">Nenhum pedido ainda.</div>
        ) : orders.map((o) => (
          <div key={o.id} className="flex items-center justify-between px-6 py-4 border-b border-white/5 last:border-0">
            <div>
              <p className="text-sm">#{o.id.slice(0, 8).toUpperCase()}</p>
              <p className="text-xs text-white/40">{o.user_email || "Convidado"} · {new Date(o.created_at).toLocaleDateString("pt-BR")}</p>
            </div>
            <div className="flex items-center gap-6">
              <span className="overline text-white/50">{o.status}</span>
              <span className="font-medium">{formatBRL(o.total)}</span>
            </div>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
}
